const tribeRoute = [
  {
    path: '/tribe/tribe-list',
    name: 'TribeList',
    authed: 'TribeList',
    component: () => import('@/views/tribe/index.vue'),
    meta: {
      tabName: 'TRIBE LIST',
      group: 'Tribe Mgmt.',
      icon: 'mdiAccountMultiple',
      groupSort: 40,
    },
  },
  {
    path: '/tribe/tribe-list/tribe-detail',
    name: 'TribeDetail',
    authed: 'TribeDetail',
    component: () => import('@/views/tribe/tribeInfo/index.vue'),
    meta: {
      tabName: 'TRIBE Detail',
      group: 'Tribe Mgmt.',
      isHide: true,
      groupSort: 40,
    },
  },
]

export default tribeRoute
